import ParseHelper from "../../../../utils/ParseHelper";
import * as React from "react";
import { Switch, Route } from "react-router-dom";
import DeploymentProcessOverview from "./DeploymentProcessOverview";
import StepDetailsLoader from "./StepDetailsLoader";
import ActionTemplateSelector from "areas/projects/components/ActionTemplateSelector/ActionTemplateSelector";
import ReloadableRoute from "components/ReloadableRoute/ReloadableRoute";

export class DeploymentProcessRoute extends React.Component<any, any> {
    static nextStepReloadPath(currentPath: string, currentKey: string): string {
        let path = currentPath;
        if (currentKey) {
            const keyNum = ParseHelper.safeParseInt(currentKey, 0) + 1;
            path = path.slice(0, -currentKey.length) + keyNum.toString();
        } else {
            path = path + "/1";
        }
        return path;
    }

    render() {
        const match = this.props.match;
        return (
            <Switch>
                <ReloadableRoute path={`${match.path}/step/new/:actionType/:template?`} component={StepDetailsLoader} />
                <ReloadableRoute path={`${match.path}/step/:stepId/new/:actionType/:template?`} component={StepDetailsLoader} />
                <ReloadableRoute path={`${match.path}/step/:stepId/:reloadKey?`} component={StepDetailsLoader} />
                <ReloadableRoute path={`${match.path}/steptemplates`} component={ActionTemplateSelector} />
                <ReloadableRoute path={`${match.path}/childsteptemplates/:parentStepId`} component={ActionTemplateSelector} />
                <ReloadableRoute path={`${match.path}`} component={DeploymentProcessOverview} />
            </Switch>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/projects/components/DeploymentProcess/DeploymentProcessRoute.tsx